import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { CustomerContext } from '../../../../contexts/customer-context';

import ButtonIcon from '../../../../component-library/button-icon';
import FormField from '../../../../component-library/form-field';
import FormSelect from '../../../../component-library/form-select';
import FormCheckbox from '../../../../component-library/form-checkbox';

const FormItem = ({
	field,
	index,
	hasOauth = false,
	handleChange,
	handleMultiSelectChange,
	setShowRefDataSearchModal,
}) => {
	const {
		refDatas = [],
	} = useContext(CustomerContext);

	const getSelectOptions = object => {
		if (object?.dataSource === 'CustomFieldDimApp.category') {
			const refDataItem = refDatas.find(item => item.code === 'CustomFieldDimApp');
			const refDataSubItem = refDataItem?.refdatalist?.find(item => item.code === 'category');
			const options = refDataSubItem?.children?.map(item => ({
				id: item.code,
				value: item.code,
				text: item.name,
			})) || [];
			return options;
		}
		return field.options;
	};

	return (
		<div className={`${field.colSpan && 'get-api-access__form-row-span'} ${field.hidden && 'display-none'}`}>
			{field.type === 'subheading' ? (
				<div className={`${field.border ? 'border-top padding-top-16' : 'padding-top-8'}`}>
					{field.label && (<h3>{field.label}</h3>)}
					{field.description && (<p>{field.description}</p>)}
				</div>
			) : null}
			{field.type === 'select' ? (
				<FormSelect
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					label={field.label}
					placeholder="Please select..."
					data={getSelectOptions(field)}
					action={e => { handleChange(index, e.target.value); }}
					id={field.id}
					name={field.id}
					value={field.value}
					required={field.required}
					error={field.error}
					disabled={field.disabled || (field?.disableIfNoOauth && !hasOauth)}
					fullWidth
				/>
			) : null}
			{field.type === 'multiselect' ? (
				<FormSelect
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					label={field.label}
					data={field.options}
					action={e => { handleMultiSelectChange(index, e.target.selectedOptions); }}
					id={field.id}
					name={field.id}
					value={field.value}
					required={field.required}
					error={field.error}
					disabled={field.disabled || (field?.disableIfNoOauth && !hasOauth)}
					isMultiSelect
					fullWidth
				/>
			) : null}
			{field.type === 'checkbox' ? (
				<FormCheckbox
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					action={e => { handleChange(index, e.target.checked); }}
					id={field.id}
					value={field.value}
					label={field.label}
					disabled={field.disabled || (field?.disableIfNoOauth && !hasOauth)}
				/>
			) : null}
			{field.type !== 'select'
				&& field.type !== 'multiselect'
				&& field.type !== 'checkbox'
				&& field.type !== 'subheading'
				&& field.type !== 'start-row'
				&& field.type !== 'start-col'
				&& field.type !== 'end-row'
				&& field.type !== 'end-col' ? (
					<>
						{field?.showRefDataSearch ? (
							<div className="get-api-access__form-row-grid">
								<div>
									<FormField
									// eslint-disable-next-line react/no-array-index-key
										key={index}
										label={field.label}
										type={field.type}
										action={e => { handleChange(index, e.target.value); }}
										id={field.id}
										name={field.id}
										value={field.value}
										required={field.required}
										error={field.error}
										readOnly={field.readOnly}
										fullWidth
										disabled={field.disabled || (field?.disableIfNoOauth && !hasOauth)}
									/>
								</div>
								<div className="get-api-access__form-row-icon">
									<ButtonIcon
										icon="magnifying-glass"
										title="Search"
										onClick={() => setShowRefDataSearchModal(true)}
									/>
								</div>
							</div>
						) : (
							<FormField
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								label={field.label}
								type={field.type}
								action={e => { handleChange(index, e.target.value); }}
								id={field.id}
								name={field.id}
								value={field.value}
								required={field.required}
								error={field.error}
								readOnly={field.readOnly}
								fullWidth
								disabled={field.disabled || (field?.disableIfNoOauth && !hasOauth)}
							/>
						)}
					</>
				) : null}
		</div>
	);
};

export default FormItem;

FormItem.propTypes = {
	field: PropTypes.shape({
		label: PropTypes.string,
		description: PropTypes.string,
		type: PropTypes.string,
		id: PropTypes.string,
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.array,
			PropTypes.bool,
		]),
		required: PropTypes.bool,
		error: PropTypes.string,
		readOnly: PropTypes.bool,
		colSpan: PropTypes.bool,
		disabled: PropTypes.bool,
		disableIfNoOauth: PropTypes.bool,
		showRefDataSearch: PropTypes.bool,
		options: PropTypes.arrayOf(PropTypes.shape({})),
		border: PropTypes.bool,
		hidden: PropTypes.bool,
	}).isRequired,
	index: PropTypes.number.isRequired,
	hasOauth: PropTypes.bool,
	handleChange: PropTypes.func.isRequired,
	handleMultiSelectChange: PropTypes.func.isRequired,
	setShowRefDataSearchModal: PropTypes.func.isRequired,
};
